import { Component, inject } from "@angular/core";
import { PiezoAlerts } from "./piezo-alerts/piezo-alerts.component";
import { PiezoAnomalyCard } from "./piezo-anomaly-status/piezo-anomaly-status.component";
import { PiezoImageContainer } from "./piezo-image/piezo-image.component";
import { PiezoTable } from "./piezo-table/piezo-table.component";
import { AssetHealthBoxComponent } from "../../../asset-health-box/asset-health-box.component";
import { ActivatedRoute, Router } from "@angular/router";
import { PiezeoDashboardService } from "../../../../app/services/piezo-dashboard.service";
import { MatMenu, MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { PiezoDashboardModal } from "./dashboard-modals/piezo-dashboard-modal.component";
import { CommonModule } from "@angular/common";
import { PiezoHealthbar } from "./piezo-healthbar/piezo-healthbar.component";
import { ConvertDatetimePipe } from "../../../../app/convert-datetime.pipe";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-piezo-dasboard",
  templateUrl: "./piezo-dashboard.component.html",
  styleUrl: "./piezo-dashboard.component.scss",
  standalone: true,
  imports: [
    PiezoAlerts,
    PiezoImageContainer,
    PiezoTable,
    MatMenu,
    MatMenuModule,
    MatIcon,
    MatButtonModule,
    PiezoDashboardModal,
    CommonModule,
    PiezoHealthbar,
    NgbNavModule,
    PiezoAnomalyCard
  ],
})
export class PiezoDashboard {
  dashborad_srv = inject(PiezeoDashboardService);
  router = inject(Router);
  modal_type: string = null;
  company_name: string = localStorage.getItem("company_name") || "";
  role: string = localStorage.getItem("role") || "";
  today = "";

  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "All Powertrains",
    },
    {
      page_ref: "#",
      page_title: "Powertrain Dashboard",
    },
  ];
  subsystem_id: string = "";
  client_id: string = "";
  intervalId: any;
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.utcTime();
    if (Object.keys(this.route.snapshot.params).length == 0) {
      let subsystem_data_stored = this.dashborad_srv.getSubsystemData();
      this.subsystem_id = subsystem_data_stored["id"];
      this.client_id = subsystem_data_stored["client_id"];
    } else {
      this.dashborad_srv.resetSubsystemData(); // clear existing data
      this.dashborad_srv.setSubsystemData(this.route.snapshot.params); // set new data
      this.subsystem_id = this.route.snapshot.params["id"];
      this.client_id = this.route.snapshot.params["client_id"];
    }
    this.fetchCurrentSubsystemData();
    this.dashborad_srv.fetchSubsystemData(this.subsystem_id).subscribe();
  }

  fetchCurrentSubsystemData(){
    this.intervalId = setInterval(() => {
    this.dashborad_srv.fetchSubsystemData(this.subsystem_id).subscribe();
  }, 30000);

  }

  ngOnDestroy(){
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  async goToPageLink(name: string) {
    this.dashborad_srv.resetSubsystemData();
    let navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        tabName: "tab-1",
        powertrain: true,
        pageRef: this.role == "ADMIN" ? "admin-emeter" : "client-piezo"
      },
    };
    if (this.role == "ADMIN") {
      name = 'device-report-new'
    }
    this.router.navigate([name], navigationExtras);
  }

  changeModalType(type: string) {
    this.modal_type = type;
  }
  closeModal() {
    this.modal_type = null;
  }
}
